import { fetchClient } from '../../Utils/helpers';
import { GET_DASHBOARD_INFO, GET_DASHBOARD_OVERVIEW } from '../actionTypes';

export function getDashboardInfo() {
  return {
    type: GET_DASHBOARD_INFO,
    payload: fetchClient({
      method: 'GET',
      url: '/admin/dashboard-info',
    }),
  };
}

export function getDashboardOverview() {
  return {
    type: GET_DASHBOARD_OVERVIEW,
    payload: fetchClient({
      method: 'GET',
      url: '/admin/dashboard-overview',
    }),
  };
}
